import {
  Component,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BrandingDataService } from 'shared/branding';
import { AppUpdateService, sentryLogger } from 'shared/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  private _update = inject(AppUpdateService);
  protected isLoading = signal(true);
  protected isBackendUnavailable = signal(false);
  protected readonly navigationVisible = signal(false);
  title = 'admin-dashboard';

  constructor(private readonly brandingService: BrandingDataService) {
    this.brandingService.applyBranding().subscribe({
      next: (result) => {
        this.isBackendUnavailable.set(result.usedDefaultColors ?? false);
        this.isLoading.set(false);
      },
      error: (err) => {
        sentryLogger.error('Failed to initialize admin dashboard branding', {
          err,
        });
        this.isBackendUnavailable.set(true);
        this.isLoading.set(false);
      },
    });
  }

  protected onRouteActivated(outlet: RouterOutlet): void {
    this.navigationVisible.set(
      outlet.activatedRouteData['hideNavigation'] !== true,
    );
  }
}
